class MainFaqs extends HTMLElement {
    constructor() {
        super();
        this.detailsElements = this.querySelectorAll('details');
        this.sidebarLinks = this.querySelectorAll('.faq-sidebar-link');
        this.faqSections = this.querySelectorAll('[data-faq-section]');
        this.HEADER_OFFSET = 50;
        this.faqItems = [];
    }

    connectedCallback() {
        /* Accordion init */
        this.faqItems = Array.from(this.detailsElements).map(
            (el) => new ProductFaqItem(el, () => this.faqItems)
        );

        /* Sidebar scroll */
        this.initSidebarScroll();

        /* Active state observer */
        this.initActiveObserver();
        this.initSeeAllButton();
    }
    initSeeAllButton() {
        const button = this.querySelector(".faq-see-all-btn");
    
        if (!button) return;
    
        button.addEventListener("click", (e) => {
            e.preventDefault();
    
            const hiddenFaqs = this.querySelectorAll(".hidden");
    
            hiddenFaqs.forEach((faq, index) => {
                faq.classList.remove("hidden");
            });
    
            const wrapper = button.closest(".faq-category-footer");
            if (wrapper) {
                wrapper.style.display = "none";
            }
        });
    }
    initSidebarScroll() {
        this.sidebarLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                const target = this.querySelector(link.getAttribute('href'));
                if (!target) return;

                const offsetTop =
                    target.getBoundingClientRect().top +
                    window.pageYOffset -
                    this.HEADER_OFFSET;

                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            });
        });
    }

    initActiveObserver() {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (!entry.isIntersecting) return;

                    const id = entry.target.id;

                    this.sidebarLinks.forEach(link => {
                        link.classList.toggle(
                            'active',
                            link.getAttribute('href') === `#${id}`
                        );
                    });
                });
            },
            {
                rootMargin: '-30% 0px -60% 0px',
                threshold: 0
            }
        );

        this.faqSections.forEach(section => observer.observe(section));
    }
}

/* ===============================
   ACCORDION ITEM (single-open behavior)
================================ */

class ProductFaqItem {
    constructor(el, getSiblings) {
        this.el = el;
        this.summary = el.querySelector('summary');
        this.content = el.querySelector('.content');
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.getSiblings = getSiblings; // function returning array of all ProductFaqItem instances
        this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
        e.preventDefault();
        this.el.style.overflow = 'hidden';

        if (this.isClosing || !this.el.open) {
            this.open();
        } else {
            this.shrink();
        }
    }

    closeOthers() {
        if (typeof this.getSiblings !== 'function') return;

        const siblings = this.getSiblings();
        siblings.forEach((item) => {
            if (item !== this && item.el.open && !item.isClosing) {
                item.shrink();
            }
        });
    }

    shrink() {
        this.isClosing = true;

        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight}px`;

        if (this.animation) this.animation.cancel();

        this.animation = this.el.animate(
            { height: [startHeight, endHeight] },
            { duration: 400, easing: 'ease-out' }
        );

        this.animation.onfinish = () => this.onAnimationFinish(false);
        this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
        // Close any other open accordion in this group before expanding
        this.closeOthers();

        this.el.style.height = `${this.el.offsetHeight}px`;
        this.el.open = true;

        requestAnimationFrame(() => this.expand());
    }

    expand() {
        this.isExpanding = true;

        const startHeight = `${this.el.offsetHeight}px`;
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        if (this.animation) this.animation.cancel();

        this.animation = this.el.animate(
            { height: [startHeight, endHeight] },
            { duration: 400, easing: 'ease-out' }
        );

        this.animation.onfinish = () => this.onAnimationFinish(true);
        this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
        this.el.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.el.style.height = '';
        this.el.style.overflow = '';
    }
}

customElements.define('main-faqs', MainFaqs);